module.exports = __webpack_public_path__ + "img/EU.f6209bac.png";